import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { type FormulaFunctionInfo } from '@blaze-shared/api-contracts-domain';
import { XhrService } from '@blaze-shared/platform-data-access';

@Injectable({ providedIn: 'root' })
export class FormulasApiService {
  private readonly xhrService = inject(XhrService);

  getFunctions(): Observable<FormulaFunctionInfo[]> {
    return this.xhrService.get<FormulaFunctionInfo[]>('formulas/functions');
  }
}
